import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react-text';
import { Button } from '@paypalcorp/pp-react-buttons';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { DOCUMENTS_REQUIRED } from '../AppPendPage/constants/slides';
import { MoreInfoIllustration } from './components/Illustration';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import { CaptionText } from './components/CaptionText';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

import './MoreIfoPage.less';

const LOCALE_PREFIX = 'US/pages/AppPendPage/MoreInfoPage';

export const MoreInfoPage = ({ navigate, intl, initialRender, doneRedirect }) => {

    React.useEffect(() => {
        initialRender();
    }, []);

    return (
        <div className="moreInfoContainer">
            <HeadingText className="moreInfoHeading" size="md">
                <FormattedMessage id={`${LOCALE_PREFIX}.header`} />
            </HeadingText>
            <div className="moreInfoPageIcon"><MoreInfoIllustration /></div>
            <CaptionText className="moreInfoSubtext moreInfoPageSubText" text={`${LOCALE_PREFIX}.subtext1`} />
            <CaptionText className="moreInfoSubtext moreInfoPageSubText" text={`${LOCALE_PREFIX}.subtext2`} />
            <CaptionText className="moreInfoSubtext moreInfoPageSubText" text={`${LOCALE_PREFIX}.subtext3`} />
            <Button
                onClick={() => {
                    doneRedirect();
                    navigate(DOCUMENTS_REQUIRED);
                }}
                className="moreInfoPageActionButton"
            >
                <FormattedMessage id={`${LOCALE_PREFIX}.btnText`} />
            </Button>
            <CancelUrl
                componentType={COMPONENT_STYLE.LINK_BUTTON}
                customCancelLinkMessage={intl.formatMessage({id: `${LOCALE_PREFIX}.linkText`})}
                className="moreInfoPageCancelLink"
                fptiEvent={{
                    stateName: 'apply_pp_credit_moreInfoPage',
                    transitionName: 'returnToCheckOut_pp_credit_moreInfoPage'
                }}
            />
        </div>
    );
};

MoreInfoPage.propTypes = {
    navigate: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    initialRender: PropTypes.func.isRequired,
    doneRedirect: PropTypes.func.isRequired
};

export const mapDispatchToProps = dispatch => ({
    initialRender() {
        dispatch(trackTransition('apply_pp_credit_moreInfoPage', 'prepare_pp_credit_moreInfoPage'));
    },
    doneRedirect() {
        dispatch(trackTransition('apply_pp_credit_moreInfoPage', 'process_pp_credit_moreInfoPage'));
    }
});

export default compose(injectIntl, connect(null, mapDispatchToProps))(MoreInfoPage);
